/** @format */

import { useContext, useEffect, useState } from 'react';

import { Route, Routes } from 'react-router';

import { Category, CreateCategory, EditCategory } from '../Components/Category';
import { City, CreateCity, EditCity } from '../Components/City';
import Dashboard from '../Components/Dashboard/Dashboard';
import {
  Create,
  Edit,
  Event,
  EventRegisterPanel,
  TeamEventRegister,
} from '../Components/Event';
import { EventEditProvince } from '../Components/EventEditProvince';
import { EventRegister } from '../Components/EventRegister';
import EditRegister from '../Components/EventRegister/EditRegister';
import { Export } from '../Components/Export';
import { CreateFandom, EditFandom, Fandom } from '../Components/Fandom';
import { CreateField, EditField, Field } from '../Components/Field';
import { CreateForm, EditForm, FormBuilder } from '../Components/FormBuilder';
import { Event as EventHome, Events, Home } from '../Components/Home';
import SelectGender from '../Components/Home/SelectGender';
import { CreateIDCard, IDCard, UpdateIDCard } from '../Components/IDCard';
import {
  CreateOrganizer,
  EditOrganizer,
  Organizer,
} from '../Components/Organizer';
import PaymentTracking from '../Components/Payment/PaymentTracking';
import EditProfile from '../Components/Profile/EditProfile';
import MyEvents from '../Components/Profile/MyEvents';
import MyParticipatedEvents from '../Components/Profile/MyParticipatedEvents';
import MyTeam from '../Components/Profile/MyTeam';
import MyTeamUsers from '../Components/Profile/MyTeamUsers';
import { CreateProvince, EditProvince, Province } from '../Components/Province';
import { Referee } from '../Components/Referee';
import Gateway from '../Components/Setting/Gateway';
import General from '../Components/Setting/General';
import {
  CreatePosition,
  EditPosition,
  Position,
} from '../Components/Position';
import { Transaction } from '../Components/Transaction';
import { UploadFile } from '../Components/UploadFiles';
import { Show, User, UserCreate, UserUpdate } from '../Components/User';
import UserRole from '../Components/User/UserRole';
import { IDCard as UserIDCard, ShowIDCard } from '../Components/UserIDCard';
import { EventContext } from '../Contexts/EventContext';
import Error403 from '../Shared/Components/Errors/Error403';
import Error404 from '../Shared/Components/Errors/Error404';
import Loading from '../Shared/Components/Loading';
import { error } from '../Shared/Components/Toast';
import useApi from '../Shared/hooks/api/Index';
import { useRole } from '../Shared/hooks/CustomHooks';

const ProtectedRoutes = () => {
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(true);
  const { can, canBoard } = useRole();

  useEffect(() => {
    const getUser = async () => {
      setLoading(true);
      await useApi.get(
        'auth/me',
        {},
        (res) => {
          eventContext.authUser = res.data.data;
          eventContext.authRoles = res.data.data?.roles ?? [];
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
      await useApi.get(
        'setting',
        {},
        (res) => {
          eventContext.setting = res.data.data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
    };
    getUser();
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <>
      <Routes>
        <Route exact path='/panel/user/profile' element={<EditProfile />} />
        <Route exact path='/panel/user/event' element={<MyEvents />} />
        <Route
          exact
          path='/panel/user/my-events'
          element={<MyParticipatedEvents />}
        />
        <Route
          exact
          path='/user/event/:id/register/edit'
          element={<EditRegister />}
        />
        <Route exact path='/panel/user/event/:id/team' element={<MyTeam />} />
        <Route
          exact
          path='/panel/user/event/:eventId/team/:teamId/users'
          element={<MyTeamUsers />}
        />
        {can('Super Admin') || can('Dyaco Admin') ? (
          <>
            <Route exact path='/panel/transaction' element={<Transaction />} />
            <Route exact path='/panel/setting/gateway' element={<Gateway />} />
            <Route exact path='/panel/setting' element={<General />} />
            <Route
              exact
              path='/panel/setting/positions/edit/:id'
              element={<EditPosition />}
            />
            <Route
              exact
              path='/panel/setting/positions/create'
              element={<CreatePosition />}
            />
            <Route
              exact
              path='/panel/setting/positions'
              element={<Position />}
            />

            <Route exact path='/panel/user/:id/role' element={<UserRole />} />
            <Route exact path='/panel/user/edit/:id' element={<UserUpdate />} />
            <Route exact path='/panel/user/create' element={<UserCreate />} />
            <Route exact path='/panel/user' element={<User />} />

            <Route
              exact
              path='/panel/sport-field/edit/:id'
              element={<EditField />}
            />
            <Route
              exact
              path='/panel/sport-field/create'
              element={<CreateField />}
            />
            <Route exact path='/panel/sport-field' element={<Field />} />

            <Route
              exact
              path='/panel/id-card/edit/:id'
              element={<UpdateIDCard />}
            />
            <Route
              exact
              path='/panel/id-card/create'
              element={<CreateIDCard />}
            />
            <Route exact path='/panel/id-card' element={<IDCard />} />

            <Route
              exact
              path='/panel/category/edit/:id'
              element={<EditCategory />}
            />
            <Route
              exact
              path='/panel/category/create'
              element={<CreateCategory />}
            />
            <Route exact path='/panel/category' element={<Category />} />
            <Route
              exact
              path='/panel/organizer/edit/:id'
              element={<EditOrganizer />}
            />
            <Route
              exact
              path='/panel/organizer/create'
              element={<CreateOrganizer />}
            />
            <Route exact path='/panel/organizer' element={<Organizer />} />
            <Route exact path='/panel/fandom' element={<Fandom />} />

            <Route
              exact
              path='/panel/fandom/create'
              element={<CreateFandom />}
            />
            <Route
              exact
              path='/panel/fandom/edit/:id'
              element={<EditFandom />}
            />
            <Route
              exact
              path='/panel/event/:id/access-province'
              element={<EventEditProvince />}
            />
          </>
        ) : null}
        {can('Super Admin') || can('Dyaco Admin') || canBoard() ? (
          <>
            <Route
              exact
              path='/panel/form-builder/edit/:id'
              element={<EditForm />}
            />
            <Route
              exact
              path='/panel/form-builder/create'
              element={<CreateForm />}
            />
            <Route exact path='/panel/form-builder' element={<FormBuilder />} />

            <Route exact path='/panel/upload' element={<UploadFile />} />

            <Route exact path='/panel/event/edit/:id' element={<Edit />} />
            <Route exact path='/panel/event/create' element={<Create />} />

            <Route exact path='/panel/referee' element={<Referee />} />
          </>
        ) : null}
        {can('Super Admin') ||
        can('Dyaco Admin') ||
        canBoard() ||
        can('Provinces') ? (
          <>
            <Route exact path='/panel/excel' element={<Export />} />
            <Route exact path='/panel/dashboard' element={<Dashboard />} />
            <Route exact path='/panel/event' element={<Event />} />\
            <Route
              exact
              path='/panel/event/:id/team'
              element={<TeamEventRegister />}
            />
            <Route
              exact
              path='/panel/event/register/:id'
              element={<EventRegisterPanel />}
            />
            <Route exact path='/panel/province' element={<Province />} />
            <Route
              exact
              path='/panel/province/create'
              element={<CreateProvince />}
            />
            <Route
              exact
              path='/panel/province/edit/:id'
              element={<EditProvince />}
            />
            <Route exact path='/panel/city/:provinceId' element={<City />} />
            <Route
              exact
              path='/panel/city/create/:provinceId'
              element={<CreateCity />}
            />
            <Route exact path='/panel/city/edit/:id' element={<EditCity />} />
          </>
        ) : null}
        <Route exact path='/payment/tracking' element={<PaymentTracking />} />
        <Route exact path='/event/register/:id' element={<EventRegister />} />
        <Route exact path='/event/show/:id' element={<EventHome />} />
        <Route exact path='/event/show/:id/gender' element={<SelectGender />} />
        <Route exact path='/event/:category' element={<Events />} />
        <Route exact path='/id-card' element={<UserIDCard />} />
        <Route exact path='/id-card/show' element={<ShowIDCard />} />
        <Route
          exact
          path='/id-card/event/:eventId/user/:userId'
          element={<Show />}
        />
        <Route exact path='/' element={<Home />} />
        <Route path='/403' element={<Error403 />} />
        <Route path='*' element={<Error404 />} />
      </Routes>
    </>
  );
};

export default ProtectedRoutes;
